<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Konsultan">Monitoring Evaluasi</a></li>
                                <li class="breadcrumb-item active">Pengaturan Kurva S</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Kurva S</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            Paket Pekerjaan: {{ Nama_Kegiatan }}
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">No</th>
                                                            <th style="width: 50px;" rowspan="2">Minggu ke-</th>
                                                            <th style="width: 100px;" colspan="2">Rencana</th>
                                                            <th style="width: 100px;" colspan="2">Realisasi</th>
                                                            <th style="width: 100px;" rowspan="2">Dokumentasi</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 50px;">Fisik (%)</th>
                                                            <th style="width: 50px;">Keuangan (Rp.)</th>
                                                            <th style="width: 50px;">Fisik (%)</th>
                                                            <th style="width: 50px;">Keuangan (Rp.)</th>
                                                        </tr>
                                                    </thead>
                                                    <div id="spinner" v-if="datamaster.length == 0"
                                                        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
                                                        style="opacity: 0.5;">
                                                        <div class="spinner-border text-danger"
                                                            style="width: 3rem; height: 3rem;" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">{{ urutlist + 1 }}</td>
                                                                <td class="text-center">{{ datalist.minggu_ke }}</td>
                                                                <td>
                                                                    <input type="number"
                                                                        class="form-control form-control-sm"
                                                                        :id="'rencana_fisik' + datalist.id"
                                                                        :name="'rencana_fisik' + datalist.id"
                                                                        placeholder="Rencana Fisik"
                                                                        :value="(datalist.rencana_fisik)"
                                                                        @change="isinumber('rencana_fisik' + datalist.id, datalist.id, 'rencana_fisik')">
                                                                </td>
                                                                <td>
                                                                    <input type="text"
                                                                        class="form-control form-control-sm"
                                                                        :id="'rencana_keuangan' + datalist.id"
                                                                        :name="'rencana_keuangan' + datalist.id"
                                                                        placeholder="Rencana Keuangan"
                                                                        @keyup="formattulisrupiah('rencana_keuangan' + datalist.id)"
                                                                        @keydown="formattulisrupiah('rencana_keuangan' + datalist.id)"
                                                                        :value="G_numFormat(datalist.rencana_keuangan)"
                                                                        @change="isirupiah('rencana_keuangan' + datalist.id, datalist.id, 'rencana_keuangan')">
                                                                </td>
                                                                <td>
                                                                    <input type="number"
                                                                        class="form-control form-control-sm"
                                                                        :id="'real_fisik' + datalist.id"
                                                                        :name="'real_fisik' + datalist.id"
                                                                        placeholder="Realisasi Fisik"
                                                                        :value="(datalist.real_fisik)"
                                                                        @change="isinumber('real_fisik' + datalist.id, datalist.id, 'real_fisik')">
                                                                </td>
                                                                <td>
                                                                    <input type="text"
                                                                        class="form-control form-control-sm"
                                                                        :id="'real_keuangan' + datalist.id"
                                                                        :name="'real_keuangan' + datalist.id"
                                                                        placeholder="Realisasi Keuangan"
                                                                        @keyup="formattulisrupiah('real_keuangan' + datalist.id)"
                                                                        @keydown="formattulisrupiah('real_keuangan' + datalist.id)"
                                                                        :value="G_numFormat(datalist.real_keuangan)"
                                                                        @change="isirupiah('real_keuangan' + datalist.id, datalist.id, 'real_keuangan')">
                                                                </td>
                                                                <td>
                                                                    <a :href="folder_foto + datalist.filenya_kurva"
                                                                        target="_blank"
                                                                        v-if="datalist.filenya_kurva != '' && datalist.filenya_kurva != null">Lihat
                                                                        Dokumentasi</a>
                                                                    <input type="hidden"
                                                                        class="form-control form-control-sm"
                                                                        :id="'filenya_kurva' + datalist.id"
                                                                        :name="'filenya_kurva' + datalist.id"
                                                                        placeholder="Dokumentasi" readonly
                                                                        :value="(datalist.filenya_kurva)">
                                                                    <input type="file"
                                                                        class="form-control form-control-sm"
                                                                        :id="'fileToUploadfilenya_kurva' + datalist.id"
                                                                        :name="'fileToUploadfilenya_kurva' + datalist.id"
                                                                        placeholder="fileToUpload"
                                                                        style="font-size: smaller;" accept="image/*">
                                                                    <br>
                                                                    <div class="progress">
                                                                        <div class="progress-bar" role="progressbar"
                                                                            aria-valuenow="0" aria-valuemin="0"
                                                                            aria-valuemax="100" style="width:0%"
                                                                            :id="'persennyafilenya_kurva' + datalist.id">
                                                                            <span
                                                                                :id="'tulisanpersenfilenya_kurva' + datalist.id">0%</span>
                                                                        </div>
                                                                    </div>
                                                                    <br>
                                                                    <span class="text-success"
                                                                        :id="'suksesnyafilenya_kurva' + datalist.id"></span>
                                                                    <br>
                                                                    <button type="button"
                                                                        class="btn btn-warning btn-sm lebar text-white"
                                                                        @click="uploadfile('filenya_kurva' + datalist.id, 'image/*', datalist.id)">Upload
                                                                        File</button>
                                                                    <button type="button"
                                                                        class="btn btn-danger btn-sm lebar"
                                                                        @click="clearfilepeta('filenya_kurva' + datalist.id, datalist.id)">Hapus
                                                                        File</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Tutup</button>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            jumlahminggu: '',
            datamaster: [],
            validasi: false,
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovationkurvas-Foto?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
        }
    },
    methods: {
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        isinumber(isi, id, kolom) {
            var isinya = document.getElementById(isi).value;

            var fd = new FormData();
            fd.append("id", id);
            fd.append("isi", isinya);
            fd.append("kolom", kolom);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationkurvas-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        isirupiah(isi, id, kolom) {
            var isinya = document.getElementById(isi).value.replaceAll(".", "").replaceAll(",", ".");

            var fd = new FormData();
            fd.append("id", id);
            fd.append("isi", isinya);
            fd.append("kolom", kolom);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationkurvas-Update", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Konsultan");
        },
        uploadfile(idnya, tipenya, idtabel) {
            //alert(idnya);
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", "filenya_kurva");
            fd.append("id", idtabel);
            fd.append("tabel", "ztable_detail_kurva_s");
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationkurvas-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                        setTimeout(() => {
                            document.location.reload();
                            // Code to execute after the 1-second delay
                        }, 500);
                        //alert(document.getElementById(idnya).value);
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
            //alert(document.getElementById(idnya).value);
            //this.isinumber(document.getElementById(idnya).value, idtabel, "filenya_kurva");
        },
        clearfilepeta(idnya, idtabel) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", "filenya_kurva");
            fd.append("filenya", document.getElementById(idnya).value);
            fd.append("id", idtabel);
            fd.append("tabel", "ztable_detail_kurva_s");
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationkurvas-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';

                    setTimeout(() => {
                        document.location.reload();
                        // Code to execute after the 1-second delay
                    }, 500);
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            //alert(document.getElementById(idnya).value);
            //this.isinumber(document.getElementById(idnya).value, idtabel, "filenya_kurva");
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.selectedid_user);
            await mainAPI.get("parastapainnovationkurvas-GetData?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.secretencData + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.Nama_Kegiatan = '';
                    this.jumlahminggu = 0;
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahminggu = Response.data.content.jumlahdata;
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.halamanloading = false;
                    }
                    else {
                        this.Nama_Kegiatan = '';
                        this.jumlahminggu = 0;
                        this.datamaster = [];
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        validasidata() {
            if (document.getElementById('nama').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('nama').focus();
                return false;
            }
            if (document.getElementById('pic').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Gambar',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var fd = new FormData();
            fd.append("nama", this.nama);
            fd.append("nama_eng", this.nama_eng);
            fd.append("project_id", this.project_id);
            fd.append("filenya_slider", document.getElementById('pic').value);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_slider-UpdateSlider", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/Slider");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.AmbilDataSingel();
    }
}
</script>
<style></style>